import { lazy } from 'react';

import { Audit } from '@/shared/types/Audit';

const OpenZeppelin = lazy(() =>
  import('@/shared/assets/auditors/openzeppelin.svg').then(module => ({
    default: module.ReactComponent,
  })),
);

const Chainsecurity = lazy(() =>
  import('@/shared/assets/auditors/chainsecurity.svg').then(module => ({
    default: module.ReactComponent,
  })),
);

const Sherlock = lazy(() =>
  import('@/shared/assets/auditors/sherlock.svg').then(module => ({
    default: module.ReactComponent,
  })),
);

const Statemind = lazy(() =>
  import('@/shared/assets/auditors/statemind.svg').then(module => ({
    default: module.ReactComponent,
  })),
);

const Decurity = lazy(() =>
  import('@/shared/assets/auditors/decurity.svg').then(module => ({
    default: module.ReactComponent,
  })),
);

const Nethermind = lazy(() =>
  import('@/shared/assets/auditors/nethermind.svg').then(module => ({
    default: module.ReactComponent,
  })),
);

export const Audits: Audit[] = [
  {
    title: 'OpenZeppelin',
    logo: <OpenZeppelin />,
    link: 'https://github.com/mellow-finance/mellow-lrt/blob/fixes/audit-sherlock-fixes/audits/202409_OpenZeppelin/Mellow%20Simple%20DVT%20Strategy%20Audit.pdf',
    auditorLink: 'https://www.openzeppelin.com/',
  },
  {
    title: 'Chainsecurity',
    logo: <Chainsecurity />,
    link: 'https://github.com/mellow-finance/mellow-lrt/blob/fixes/audit-sherlock-fixes/audits/202408_ChainSecurity/ChainSecurity_Mellow_Finance_Mellow_LRT_audit.pdf',
    auditorLink: 'https://www.chainsecurity.com/',
  },
  {
    title: 'Statemind',
    logo: <Statemind />,
    link: 'https://github.com/mellow-finance/mellow-lrt/blob/main/audits/202405_Statemind/Mellow%20LRT%20Final%20report.pdf',
    auditorLink: 'https://statemind.io/',
  },
  {
    title: 'Sherlock',
    logo: <Sherlock />,
    link: 'https://github.com/mellow-finance/mellow-lrt/blob/fixes/audit-sherlock-fixes/audits/202406_Sherlock/Mellow%20Modular%20LRTs%20Audit%20Report.pdf',
    auditorLink: 'https://sherlock.xyz/',
  },
  {
    title: 'Decurity',
    logo: <Decurity />,
    link: 'https://github.com/mellow-finance/mellow-interop/blob/main/audits/202503_Decurity/Mellow%20Interop%20v2%20Audit%20Final%20Report.pdf',
    auditorLink: 'https://www.decurity.io/',
  },
  {
    title: 'Nethermind',
    logo: <Nethermind />,
    link: 'https://github.com/mellow-finance/mellow-interop/blob/main/audits/202503_Nethermid/NM_0468_Mellow.pdf',
    auditorLink: 'https://www.nethermind.io/nethermind-security',
  },
];
